export const env = {
  apiVersion: 'v2',
  basePath: process.env.REACT_APP_BASE_URL,
  clientBasePath: 'cliente',
  commercialStructure: 'estrut-comerc',
  creditByClientIdBasePath: 'CreditoClienteByID',
  downloadFilesBaseUrl: process.env.REACT_APP_DOWNLOAD_FILES_BASE_URL,
  draftBasePath: 'rascunho',
  maintenanceOVBasePath: 'editar-ordem-venda',
  manageOVBasePath: 'gerir-ov',
  mesCotaRequestPah: process.env.REACT_APP_BASE_MES_COTA,
  ovDetailBasePath: 'detalhes',
  ovDetailedInfo: 'informacoes-adicionais',
}
